import type { EnrollCourse201OneOf } from './enrollCourse201OneOf';
import type { EnrollCourse201OneOfThree } from './enrollCourse201OneOfThree';
import type { EnrollCourse201OneOfFive } from './enrollCourse201OneOfFive';

export type EnrollCourse201 = EnrollCourse201OneOf | EnrollCourse201OneOfThree | EnrollCourse201OneOfFive;
